import { FC } from 'react';

interface IconProps {
  className?: string;
}

const DocumentMask: FC<IconProps> = ({ className }) => (
  <svg
    viewBox="0 0 338 482"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="xMidYMid meet"
  >
    <rect
      x="2"
      y="2"
      width="334"
      height="478"
      rx="8"
      stroke="#81EFBD"
      strokeWidth="4"
    />
  </svg>
);

export default DocumentMask;
